import React from 'react';

import { ReceiverPageView } from './component';

export const ReceiverPage: React.FC = () => <ReceiverPageView data-test="receiver" />;

export default ReceiverPage;
